<mat-dialog-content class="mat-typography">
    <h2>{{ piece.id ? 'Modification' : 'Ajout' }} d'une pièce</h2>
    <form class="grid grid-cols-1 xl:grid-cols-2 gap-4 w-full px-8" [formGroup]="form" (ngSubmit)="onFormSubmit()">

        <mat-form-field>
            <mat-label>Nom de la pièce</mat-label>
            <input type="text"
                   matInput
                   formControlName="nom_piece"
                   [matAutocomplete]="nomPieceInput">
            <mat-autocomplete #nomPieceInput="matAutocomplete">
                <mat-option *ngFor="let option of nomPiecesAutofill" [value]="option">{{option}}</mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field *ngIf="form.value.nom_piece === 'Autre'">
            <mat-label>Préciser le nom de la pièce</mat-label>
            <input type="text" matInput formControlName="autrePiece">
        </mat-form-field>

        <mat-form-field>
            <mat-label>Étage</mat-label>
            <input type="text"
                   matInput
                   formControlName="nom_niveau"
                   [matAutocomplete]="etageInput">
            <mat-autocomplete #etageInput="matAutocomplete">
                <mat-option *ngFor="let option of niveauxAutofill" [value]="option.nom_niveau">{{option.nom_niveau}}</mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Revêtement plancher</mat-label>
            <input type="text"
                   matInput
                   formControlName="revetement_plancher"
                   [matAutocomplete]="revetementInput">
            <mat-autocomplete #revetementInput="matAutocomplete">
                <mat-option *ngFor="let option of revetementsPlanchersAutofill" [value]="option.revetement">{{option.revetement}}</mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Largeur</mat-label>
            <input type="text" matInput formControlName="largeur">
        </mat-form-field>

        <mat-form-field>
            <mat-label>Hauteur</mat-label>
            <input type="text" matInput formControlName="hauteur">
        </mat-form-field>

        <mat-form-field>
            <mat-label>Longueur</mat-label>
            <input type="text" matInput formControlName="longueur">
        </mat-form-field>
    </form>
</mat-dialog-content>


<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="undefined">Annuler</button>
    <button type="submit" mat-flat-button (click)="onFormSubmit()" [color]="'primary'">Enregistrer</button>
</mat-dialog-actions>
